import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Requisition } from 'src/app/models/requisition';
import { RequisitionLine } from 'src/app/models/requisition-line';
import { NgbDateAdapter, NgbDateNativeAdapter, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrManager } from 'ng6-toastr-notifications';
import { ArticleService } from 'src/app/services/article.service';
import { SupplierService } from 'src/app/services/supplier.service';
import { UnityService } from 'src/app/services/unity.service';
import { Article } from 'src/app/models/article';
import { Supplier } from 'src/app/models/supplier';
import { Unity } from 'src/app/models/unity';
import { RequisitionService } from 'src/app/services/requisition.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { CustomerService } from 'src/app/services/customer.service';
import { Customer } from 'src/app/models/customer';
import { Select2OptionData } from 'ng2-select2';
import { forEach } from 'lodash';

@Component({
  selector: 'app-requisition-create',
  templateUrl: './requisition-create.component.html',
  styleUrls: ['./requisition-create.component.css'],
  providers: [{provide: NgbDateAdapter, useClass: NgbDateNativeAdapter}]
})
export class RequisitionCreateComponent implements OnInit {
  actualUser:string = "";
  requisition:Requisition = new Requisition();
  requisitionLine:RequisitionLine = new RequisitionLine();

  articles:Article[] = [];
  article:Article = null;
  suppliers:Supplier[] = [];
  supplier:Supplier = null;
  customers:Customer[] = [];
  customer:Customer = null;
  unities:Unity[] = [];
  unity:Unity = null;

  loading:boolean = false;
  //Filtros con busqueda
  suppliersMap:any[] = [];
  articlesMap:any[] = [];
  customersMap:any[] = [];
  unitiesMap:any[] = [];
  //
  article_id:any = null;
  supplier_id:any = null;
  unity_id:any = null;
  customer_id:any = null;

  constructor( private auth:AuthService, private toastr:ToastrManager, private articleServ:ArticleService, private supplierServ:SupplierService, private unityServ:UnityService, private modal:NgbModal, private requisitionServ:RequisitionService, private utl:UtilitiesService, private customerServ:CustomerService ) { }

  ngOnInit() {
    let user = this.auth.getActualUser();
    this.actualUser = `${user.name} ${user.last_name}`;

    this.loading = true;
    this.articleServ.getArticles().then(articles => {
      this.articles = articles;
      //Mapear Array de Articulos
      for(let a = 0; a < this.articles.length; a++){
        this.articlesMap.push({id: this.articles[a].id, text: this.articles[a].name});
      }
      this.article_id = this.articlesMap[0].id;
      this.article = this.articles[0];
    });
    this.supplierServ.getSuppliers().then(suppliers => {
      this.suppliers = suppliers;
      //Mapear Array de Proveedores
      this.suppliersMap.push({id: 'null', text: 'Ninguno'});
      for(let b = 0; b < this.suppliers.length; b++){
        this.suppliersMap.push({id: this.suppliers[b].id, text: this.suppliers[b].business_name})
      }
      this.supplier_id = this.suppliersMap[0].id;
    });
    this.unityServ.getUnities().then(unities => {
      this.unities = unities.filter(uni=>uni.unit_type.name != 'Contratistas');
      //Mapear Array de Unidades
      this.unitiesMap.push({id: 'null', text: 'Ninguno'});
      for(let c = 0; c < this.unities.length; c++){
        let type = "";
        if(this.unities[c]){
          type = "NE: " + this.unities[c].id + " - " + this.unities[c].unit_type.name + " " + this.unities[c].brand + " (" + this.unities[c].model + ") PL: " + this.unities[c].licence_plate
        }
        this.unitiesMap.push({id: this.unities[c].id, text: type})
      }
      this.unity_id = this.unitiesMap[0].id;
      this.loading = false;
    });
    this.customerServ.getCustomers('Compañia').then(customers => {
      this.customers = customers;
      //Mapeo de Array de Compañias
      this.customersMap.push({id: 'null', text: 'Ninguno'});
      for(let d = 0; d < this.customers.length; d++){
        this.customersMap.push({id: this.customers[d].id, text: this.customers[d].name});
      }
      this.customer_id = this.customersMap[0].id;
    });
  }

  updateSupplier(event){
    if(event['value'] != 'null')
      this.supplier = this.suppliers.find(e => e.id == event['value']);
  }

  updateArticle(event){
    if(event['value'] != null)
      this.article = this.articles.find(e => e.id == event['value']);
  }

  updateCustomer(event){
    if(event['value'] != 'null')
      this.customer = this.customers.find(e => e.id == event['value']);
  }

  updateUnity(event){
    if(event['value'] != 'null')
      this.unity = this.unities.find(e => e.id == event['value']);
  }

  freshArticles() {
    this.loading = true;
    this.articleServ.getArticles().then(articles => {
      this.articles = articles;
      this.article = this.articles[0];
      this.loading = false;
    });
  }

  save(event) {
    event.preventDefault();
    
    if(this.canSave()){
      this.loading = true;
      this.requisitionServ.postRequisition(this.requisition).then(req => {
        this.requisition = new Requisition();
        this.toastr.successToastr(`Requisición creada con el número ${req.id}`);
        this.loading = false;
        this.defaultValuesItems();
      }).catch(e => {
        this.toastr.errorToastr(this.utl.formatMessages(e))
        this.loading = false;
      });
    }
  }

  canSave(){
    //Validacion de partidas
    if(this.requisition.lines.length == 0) this.toastr.infoToastr("Es requerido que exista por lo menos una linea.");
    return (
      this.requisition.lines.length > 0
    );
  }

  getTotal() {
    return this.requisition.lines.filter(ln => ln.status != 'Cancelado').map(ln => ln.quantity * ln.unit_price * (ln.iva*1 + 1)).reduce((act, ant) => act + ant, 0);
  }

  openModal(m) {
    this.modal.open(m, {size: 'lg'});
  }

  selectArticle() {
    this.requisitionLine.article_id = this.article.id;
    this.requisitionLine.article_name = this.article.name;
    this.requisitionLine.measure_unit = this.article.measure_unit;
    this.article_id = this.article.id;
  }

  selectSupplier() {
    this.requisitionLine.supplier_id = this.supplier ? this.supplier.id : null;
    this.requisitionLine.supplier_name = this.supplier ? this.supplier.business_name : null;
    this.supplier_id = this.supplier ? this.supplier.id : 'null';
  }

  selectCustomer() {
    this.requisitionLine.customer_id = this.customer ? this.customer.id : null;
    this.requisitionLine.customer_name = this.customer ? this.customer.name : null;
    this.customer_id = this.customer ? this.customer.id : 'null';
  }

  selectUnity() {
    this.requisitionLine.unity_id = this.unity ? this.unity.id : null;
    this.requisitionLine.customer_id = this.unity ? this.unity.customer.id : null;
    this.requisitionLine.customer_name = this.unity ? this.unity.customer.name : null;
    this.unity_id = this.unity ? this.unity.id : 'null';
  }

  addline() {
    if(this.requisitionLine.comments.trim() != ""){
      if (this.requisitionLine.article_id && this.requisitionLine.quantity && this.requisitionLine.customer_id) {
        if(this.canAddLine()){
          this.isLineSap();
          this.requisition.lines.push(Object.assign({}, this.requisitionLine));
          this.requisitionLine = new RequisitionLine();
          this.toastr.infoToastr('Artículo agregado correctamente a la requisición');
          this.defaultValuesItems();
        }else{
          this.toastr.infoToastr("¡Solo puedes crear requisiciones de nutrimentos si todas las lineas a este!");
        }
      } else {
        this.toastr.infoToastr("El artículo, la cantidad y la empresa son campos obligatorios!");
      }
    }else{
      this.toastr.infoToastr('Debes agregar comentarios a la partida');
    }
  }

  canAddLine(){
    if(this.requisition.lines.length == 0){
      return true;
    }else if(this.requisitionLine.customer_id == 6){
      return (this.requisition.lines[0].customer_id == 6)? true : false;
    }else if(this.requisition.lines[0].customer_id != 6){ return true; }
  }

  isLineSap(){
    if(this.requisitionLine.customer_id == 6){
      this.requisitionLine.is_sap = true;
    }
  }

  removeLine(line:RequisitionLine) {
    this.requisition.lines = this.requisition.lines.filter(l => l != line);
  }

  defaultValuesItems(){
    this.article_id = this.articlesMap[0].id;
    this.article = this.articles[0];

    this.supplier_id = this.suppliersMap[0].id;
    this.supplier = null;

    this.unity_id = this.unitiesMap[0].id;
    this.unity = null;

    this.customer_id = this.customersMap[0].id;
    this.customer = null;
  }
}
